<template>
	<Modal v-if="shown"
		   :title="$t('marketSoundingDecision.messageModal.title')"
		   :sub-title="$t('marketSoundingDecision.messageModal.subTitle')"
		   @close="show(false)"
		   :close-on-click-outside="true"
		   :width="500"
	>
		<template v-slot:body>
			<div class="text_left scroll_y_auto" style="max-height: calc(100vh - 300px);">
				<div class="note_with_divider" v-for="message in messageList" :key="message.id">
					<div class="base_margin">
						<p class="upper_box">{{ $t("marketSoundingDecision.messageModal.message.added", {creationTime: message.creationTime}) }}</p>
						<hr class="">
						<p class="lower_box">{{message.message}}</p>
					</div>
				</div>

				<p v-if="messageList.length > 0" class="font_bold" v-html="$t('marketSoundingDecision.messageModal.message.addAnother')"></p>
				<p v-else v-html="$t('marketSoundingDecision.messageModal.text')"></p>

				<form>
					<md-field>
						<md-textarea class="textarea note-textarea base_padding"
									 v-model="form.message"
									 md-autogrow
									 required
						></md-textarea>
					</md-field>
					<div class="flex flex_space">
						<md-button @click="close" class="md-blank">
							{{ $t("common.button.close") }}
						</md-button>
						<md-button @click="submit" class="md-primary">
							{{ $t("common.button.submit") }}
						</md-button>
					</div>
				</form>
			</div>
		</template>
	</Modal>
</template>
<script>

import Modal from "@/components/templates/modal/Modal";
import {marketSoundingDecisionApi} from "@/common/api/marketSoundingDecisionApi";

export default {
	components: {
		Modal
	},
	data() {
		return {
			shown: false,
			form: {
				decisionId: null,
				message: null
			},
			messageList: []
		};
	},
	methods: {
		show(value) {
			this.shown = value;
		},
		showMessageModal(data) {
			let decisionId = data.decisionId;
			this.form.decisionId = decisionId;
			this.form.message = null;

			marketSoundingDecisionApi.inspection.getMessageList(decisionId).then((res) => {
				this.messageList = res;
				this.show(true);
			}).catch(this.toast);
		},
		close() {
			this.show(false);
		},
		submit() {
			if (!this.form.message) {
				this.toast(this.$t('marketSoundingDecision.messageModal.warning'));
				return;
			}

			marketSoundingDecisionApi.operation.sendMessage(this.form.decisionId, this.form.message)
				.then(() => {
					this.toastSuccess();
					this.show(false);
					this.$emit("messageSent");
					}
				).catch(this.toast);
		}
	},
};
</script>
